// Client-side mirrors of api/helpers/access.js. Purely cosmetic gating —
// the server enforces the real checks. Until the user record has loaded
// (auth.user.email empty) we err on the side of showing write UI; a
// read-only user who races a click just gets a 403 snackbar.
const userLoaded = (auth) => Boolean(auth?.user?.email);

export const canWriteCid = (auth, cid) => {
  if (auth?.admin) {
    return true;
  }
  if (!userLoaded(auth)) {
    return true;
  }
  return Boolean(cid && (auth.user.write_permissions || []).includes(cid));
};

export const canWriteAnyCid = (auth) => {
  if (auth?.admin) {
    return true;
  }
  if (!userLoaded(auth)) {
    return true;
  }
  return (auth.user.write_permissions || []).length > 0;
};
